<template>
  <svg width="26" height="32" viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 1H4C3.20435 1 2.44129 1.31607 1.87868 1.87868C1.31607 2.44129 1 3.20435 1 4V28C1 28.7956 1.31607 29.5587 1.87868 30.1213C2.44129 30.6839 3.20435 31 4 31H22C22.7956 31 23.5587 30.6839 24.1213 30.1213C24.6839 29.5587 25 28.7956 25 28V10L16 1Z" stroke="#111111" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16.4277 1V10.4286H24.9992" stroke="#111111" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 17.2861H7" stroke="#111111" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 23.2861H7" stroke="#111111" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.4286 11.2861H8.71429H7" stroke="#111111" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'FileIcon',
  props: {

  },
  computed: {

  }
};
</script>
<style scoped lang="scss">

</style>
